var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "LMSearch" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "searchNumberType" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.queryForm.params.numberType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "numberType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.numberType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("newOrder.waybillNumber"),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "placeOrder.scanOrderNumber"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.max2000Line"
                              ),
                              rows: 1,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.queryForm.params.waybillNumbers,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "waybillNumbers",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.waybillNumbers",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("fixDutyFine.DefiniteTime") },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "picker-options": _vm.pickerOptions,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.handleTimeChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("fixDutyFine.DefiniteType") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value:
                                  _vm.queryForm.params.responsibilityTypeList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "responsibilityTypeList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.responsibilityTypeList",
                              },
                            },
                            _vm._l(
                              _vm.responsibilityTypeList.responsibility_type,
                              function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.value, value: item.key },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.ResponsibleBranch"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.siteIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "siteIdList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.siteIdList",
                              },
                            },
                            _vm._l(_vm.siteIdList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.getTableData },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.search")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.advancedSearch },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("home.advancedSearch")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", size: "small" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")) + " ")]
                      ),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small" },
                          model: {
                            value: _vm.queryForm.params.isTest,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "isTest", $$v)
                            },
                            expression: "queryForm.params.isTest",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                          ]),
                          _c("el-radio-button", { attrs: { label: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small" },
                          on: { click: _vm.orderNumberExport },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("collectionCenter.BulkExport")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.getSelectedConditions().length
                ? _c(
                    "div",
                    { staticClass: "selected-conditions" },
                    [
                      _c("span", { staticClass: "selected-label" }, [
                        _c("i", { staticClass: "el-icon-filter" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("seller.selectedConditions")) +
                            ": "
                        ),
                      ]),
                      _vm._l(_vm.getSelectedConditions(), function (item) {
                        return _c(
                          "el-tag",
                          {
                            key: item.key,
                            staticClass: "selected-tag",
                            attrs: { closable: "", size: "medium" },
                            on: {
                              close: function ($event) {
                                return _vm.removeCondition(item.key)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.label) +
                                ": " +
                                _vm._s(item.value) +
                                " "
                            ),
                          ]
                        )
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "clear-all-btn",
                          attrs: { type: "text" },
                          on: { click: _vm.clearAllConditions },
                        },
                        [
                          _c("i", { staticClass: "el-icon-delete" }),
                          _vm._v(" " + _vm._s(_vm.$t("seller.clearAll")) + " "),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "LMTable" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.deductionAmountData,
                  "header-cell-style": {
                    background: "#f2f2f2",
                    color: "black",
                    textAlign: "center",
                  },
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", label: "", prop: "numberVotes" },
                }),
                _vm._l(_vm.tableColumn1, function (item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      align: item.align,
                      "class-name": item.className,
                      label: item.label,
                      prop: item.prop,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getResponsibilityType(
                                        item.prop,
                                        1
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.tableData1,
                  "header-cell-style": {
                    background: "#f2f2f2",
                    color: "black",
                    textAlign: "center",
                  },
                  border: "",
                },
              },
              _vm._l(_vm.tableColumn2, function (item, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    align: item.align,
                    "class-name": item.className,
                    label: item.label,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getResponsibilityType(
                                      item.prop,
                                      2
                                    )
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(scope.row[item.prop]) + " ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              1
            ),
          ],
          1
        ),
        _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
          _c(
            "div",
            [
              _vm._v(" " + _vm._s(_vm.$t("navbar.gong")) + " "),
              _c("span", { staticStyle: { color: "#00a551" } }, [
                _vm._v(_vm._s(_vm.total)),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("fixDutyFine.Item")) + " "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:LMLiabilityForLosses:Import",
                      expression: "'btn:LMLiabilityForLosses:Import'",
                      arg: "remove",
                    },
                  ],
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.openBatchImportWindow },
                },
                [_vm._v(_vm._s(_vm.$t("navbar.orderImport")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:LMLiabilityForLosses:fixAbility",
                      expression: "'btn:LMLiabilityForLosses:fixAbility'",
                      arg: "remove",
                    },
                  ],
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.openChangeWindow },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("fixDutyFine.modifyResponsibility")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:LMLiabilityForLosses:batchUpdateDeduction",
                      expression:
                        "'btn:LMLiabilityForLosses:batchUpdateDeduction'",
                      arg: "remove",
                    },
                  ],
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.batchUpdateDeduction },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("ClaimsManagement.batchUpdateDeductionStatus")
                    ) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.exportExcel },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.tableData,
                  "header-cell-style": {
                    background: "#f2f2f2",
                    color: "black",
                    textAlign: "center",
                  },
                  border: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", type: "selection", width: "50" },
                }),
                _vm._l(_vm.tableColumn, function (item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      align: item.align,
                      "class-name": item.className,
                      label: item.label,
                      "min-width": item.width,
                      prop: item.prop,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              item.prop === "waybillNumber"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toOrderDetail(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.waybillNumber) +
                                          " "
                                      ),
                                    ]
                                  )
                                : item.prop === "tag"
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.LOST_TYPE[scope.row[item.prop]]
                                            .label
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _c("div", [
                                    _vm._v(_vm._s(scope.row[item.prop])),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
            _c("el-pagination", {
              staticStyle: { margin: "20px 0", "text-align": "right" },
              attrs: {
                "current-page": _vm.queryForm.pageNumber,
                "page-size": _vm.queryForm.pageSize,
                "page-sizes": [10, 50, 100, 200, 400],
                total: _vm.total,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("placeOrder.orderImport"),
            visible: _vm.isBatchImportWindow,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isBatchImportWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("batchImport", {
                key: _vm.isBatchImportWindow,
                ref: "batchImport",
                attrs: {
                  "branch-enable-list": _vm.branchEnableList,
                  "import-type": _vm.importType,
                  "responsibility-type-list": _vm.responsibilityTypeList,
                  "site-id-list": _vm.siteIdList,
                },
                on: { confirmImportData: _vm.confirmImportData },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.importType === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.isBatchImportWindow = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.confirmImport },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.importType === 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.isBatchImportWindow = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.close")) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("fixDutyFine.modifyResponsibility"),
            visible: _vm.isChangeWindow,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isChangeWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("changeSite", {
                key: _vm.isChangeWindow,
                ref: "changeWindow",
                attrs: {
                  "branch-enable-list": _vm.branchEnableList,
                  "change-type": _vm.changeType,
                  "responsibility-type-list": _vm.responsibilityTypeList,
                  "selected-data": _vm.selectedData,
                  "site-id-list": _vm.siteIdList,
                },
                on: { changeSiteData: _vm.changeSiteData },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.changeType === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.isChangeWindow = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.confirmChange },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.changeType === 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.isChangeWindow = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.close")) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("orderCenterCont.LogisticsOrders"),
            visible: _vm.waybillDescription,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waybillDescription = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("waybill-information", {
                key: _vm.showQueryTrack.trackKey,
                attrs: { "query-track-param": _vm.TrackParam },
              }),
            ],
            1
          ),
        ]
      ),
      _c("exportOrderNumber", { ref: "exportOrderNumberRef" }),
      _c("batchDebitStatus", {
        ref: "batchDebitStatusRef",
        on: { emitSearch: _vm.getTableData },
      }),
      _c("search-com", {
        ref: "searchComRef",
        attrs: {
          "region-list": _vm.regionList,
          "responsibility-type-list": _vm.responsibilityTypeList,
          "state-option-list": _vm.stateOptionList,
          "transit-center-option-list": _vm.transitCenterOptionList,
        },
        on: { search: _vm.advancedSearchEvent },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }